import type { CheckoutRequest, CheckoutResponse, SubscriptionResponse } from '@tabita/contracts';
import { apiRequest } from './api-client';

export const billingApi = {
  getSubscription() {
    return apiRequest<SubscriptionResponse | null>('/billing/subscription');
  },

  checkout(body: CheckoutRequest) {
    return apiRequest<CheckoutResponse>('/billing/checkout', { method: 'POST', body });
  },
};
